let changeMap = function(lat, lng) {
  if (lat && lng) {
    let a = this.location(lat, lng);
    return a;
  }
};
changeMap.prototype = {
  location(lat, lng) {
    //110.32258597578102, y: 22.707556118439232 右111.67733756269487, y: 21.4170409549295
    // 计算方法右下-0.00441741943359375, lng: 0.00424957275390625 左上 {lat: -0.00003814697265625, lng: 0.00006866455078125}
    // 获取原地图范围坐标 左上角{lat: 21.50737970898609, lng:109.66415405273438} 右下角{lat: 20.992855321748024, lng: 110.42083740234376}
    // 原地图左上角减去右下角的经度 109.66415405273438-110.42083740234376 = -0.7566833496093892
    let percentLng = Number(110.32258597578102 - 111.67733756269487);
    // 原地图左上角减去右下角的纬度 21.50737970898609-20.992855321748024 = 0.5145243872380654
    let percentLat = Number(22.707556118439232 - 21.4170409549295);
    // 获取标注点的经纬度 [lat:21.42043231963583, lng:110.21106719970705]
    let taggLng = Number(lng);
    let taggLat = Number(lat);
    // 根据计算获得标注点相对左上角点位移的百分比 经度 (110.21106719970705-109.66415405273438)/-0.7566833496093892 = -0.722776769509987
    let taggPerLng = (taggLng - 110.32258597578102) / percentLng;
    // 根据计算获得标注点相对左上角点位移的百分比 纬度 (21.42043231963583-21.50737970898609)/0.5145243872380654 = -0.16898594412013965
    let taggPerLat = (taggLat - 22.707556118439232) / percentLat;
    // 自定义地图的左上角的点为[0,0] 右下角{lat: -0.00370025634765625, lng: 0.0057830810546875}
    // 自定义地图标注点相对右上角点位移的百分比 经度 -0.722776769509987= taggPerLng
    // 自定义地图标注点相对右上角点位移的百分比 纬度 -0.16898594412013965 = taggPerLat
    // 自定义地图标注点经度计算 0-(0.00506591796875*-0.722776769509987) = 0.0036615278240557203
    let symLat = 0 - -0.004427751523530194 * taggPerLat;
    let symLng = 0 - 0.004301187830732278 * taggPerLng;
    // 自定义地图标注点纬度计算 0-(-0.0031890869140625*-0.16898594412013965) = -0.0005389108630540342
    let obj = {
      lat: symLat,
      lng: symLng
    };
    return obj;
  }
};
export default changeMap;
